import { AxiosError } from 'axios';
import { GenericErrorResponse } from '../../api';
import axiosClient from '../axiosClient';
import {
  POST_GROUP_EXAM_REGISTRATION,
  POST_GROUP_EXAM_REGISTRATION_TOKEN,
} from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';

interface PostCreateExamRegistrationResponse {
  uuid: string;
}

interface Input {
  examType: string;
  token: string | null;
  onSuccess?: (data: PostCreateExamRegistrationResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateGroupExamRegistration = ({
  examType,
  token,
  onSuccess,
  onError,
}: Input) => {
  const postCreateGroupExamRegistration = async () => {
    const url = token ? POST_GROUP_EXAM_REGISTRATION_TOKEN(token) : POST_GROUP_EXAM_REGISTRATION;
    const res = await axiosClient.post<PostCreateExamRegistrationResponse>(url, { examType });
    return res.data;
  };
  return useCustomMutation(postCreateGroupExamRegistration, {
    onSuccess,
    onError,
  });
};
